<template>
  <v-row justify="center" align="center" style="min-height: 60vh">
    <v-col cols="12">
      <v-card flat style="text-align: center">
        <div style="font-size: 24px">Ready to create your first job?</div>
        <br />
        Click the “Create Job” button on the left below to get started.<br />
        Have any questions? Click the “Learn More” button to the right.<br />
        <v-row justify="center" class="mb-2 mt-3">
          <v-col cols="auto">
            <v-btn
              color="primary"
              @click="jobCreation"
              data-cy="job-table-btn-add"
            >
              Create Job
            </v-btn>
          </v-col>
          <v-col cols="auto">
            <v-dialog v-model="dialog" max-width="800">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  color="primary"
                  data-cy="job-table-btn-add"
                >
                  Learn More
                </v-btn>
              </template>
              <v-card
                class="p-5"
                style="
                  width: 100%;
                  text-align: center;
                  max-height: 500px;
                  overflow: scroll;
                "
              >
                <div style="padding: 20px">
                  <div style="font-size: 22px; margin-bottom: 10px">
                    Creating your first Job
                  </div>
                  <div>
                    A “job” is any commercial, music video, etc.. that you are
                    using FPS to streamline timecard/invoice management for.
                    <br /><br />
                  </div>
                  <div>
                    Fill out the form, go through the checkout page, and voila!
                    You will see a job appear, as shown below. From there you
                    will be able to access links / qrcodes to distribute to crew
                    on the job.<br/> <br/>
                    <b>Note:</b> You must pay for the job before you can access links for distributing the digital form.
                    <br /><br />
                    <span style="color: black">
                      <img width="100%" :src="jobExamplePhoto" />
                    </span>
                  </div>
                  <div>Ready to get started?</div>
                  <v-row justify="center" class="mb-2 mt-3">
                    <v-col cols="auto">
                      <v-btn
                        color="primary"
                        @click="jobCreation"
                        data-cy="job-table-btn-add"
                      >
                        Create Job
                      </v-btn>
                    </v-col>
                    <v-col cols="auto">
                      <v-btn
                        outlined
                        color="primary"
                        @click="dialog=false"
                        data-cy="job-table-btn-add"
                      >
                        Close
                      </v-btn>
                    </v-col>
                  </v-row>
                </div>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>
        <v-row justify="center" class="mb-2 mt-3">
          <v-col cols="auto">
            <iframe
              width="560"
              height="315"
              src="https://www.loom.com/embed/361e7f9520d6490d818b445167270f6f"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            >
            </iframe>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { getUser } from "../services/users";
import jobExamplePhoto from '../assets/job_example.png';

export default {
  data() {
    return {
      jobExamplePhoto,
      dialog: false
    }
  },
  async mounted() {
    let current_user = await getUser();
    this.isSuperUser = current_user["data"]["is_superuser"];
  },
  methods: {
    jobCreation() {
      if (this.isSuperUser) {
        this.$router.push({ name: "jobs-create-admin" });
      } else {
        this.$router.push({ name: "jobs-create" });
      }
    },
  },
};
</script>